// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GlobeADefault } from '../../../assets/icons/default/maps_travel/globe-a.svg?react';
import { ReactComponent as GlobeASolid } from '../../../assets/icons/solid/maps_travel/GLOBE-A.svg?react';
import { createIcons } from '../../Icon';
const GlobeAIcon = /* @__PURE__ */ createIcons('GlobeA', {
    default: GlobeADefault,
    solid: GlobeASolid
});
GlobeAIcon.supportedTypes = ['default', 'solid'];
GlobeAIcon.category = 'maps_travel';
export default GlobeAIcon;
